<template>
  <v-container grid-list-xl>
    <v-layout wrap align-center>
      <v-flex xs12>
        <v-card>
          <v-toolbar color="blue darken-3" dark>
            <v-toolbar-side-icon></v-toolbar-side-icon>

            <v-toolbar-title>Help</v-toolbar-title>

            <v-spacer></v-spacer>


          </v-toolbar>

          <v-expansion-panels>
            <v-expansion-panel
                    v-for="(item,i) in items"
                    :key="i"
            >
              <v-expansion-panel-header class="blue--text">{{item.name}}</v-expansion-panel-header>
              <v-expansion-panel-content>

               {{item.text}}
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { router } from "../router";
import jwt_decode from "jwt-decode";
import { checkLogin } from '../helpers/check'

export default {
  data: () => ({
    items: [
      {
        name: "How do I add my site information?",
        text: "To add the location of your site, select “My Sites” in the menu on the left hand side of the screen. " +
        "Under the Search and Add a Site for Inspection heading, begin entering your Strata Property Address. Once the correct address appears, select ADD. " +
        "A pin drop will now indicate your site on the map of Australia and your Site Address will appear below. "
      },
      {
        name: "How do I add my preferred inspection schedule?",
        text: "After you have added your site you may enter your preferred date range for your inspection to take place. " +
        " The date range may be entered under the site address. While we will endeavor to meet your preferred dates, " +
        "due to inspector’s locations and availability, we may not always be able to meet these requirements. " +
        "The Inspectors will discuss and finalise dates with you, as the Authorised Person, after you have " +
        "submitted your site information."

      },
      {
        name: "How do I add buildings to my site?",
        text: "Add buildings to your site by clicking the \"ADD BUILDING\" button under your site address. " +
        "You do NOT need to add a different building per unit/residence. If your property has a number of " +
        "the same style of building with the same or very similar floor plans, numbers of storeys and were " +
        "all built within two years or less of each other, they can be considered as one \"type\" of building. "

      },
      {
        name: "How do I add details about my site?",
        text: "Add details about your site by clicking \" ADD SITE DETAILS\". Although prefilling the site information is not mandatory, " +
        "please try and provide as much information as possible. "

      },
      {
        name: "Do I have to provide the Community Title Scheme Number for each of my inspection sites?",
        text: "Yes, the Community Title Scheme Number (CTS Number) has to be provided for each site."
      },
      {
        name: "What other information do I have to provide about my inspection site?",
        text: "You may enter more information about your site after you have added it. This information " +
        "will be provided to the Inspector before they commence your inspection. " +
        "Although this information is not mandatory, the more information you can enter, the more helpful this " +
        "will be for the inspectors when they visit the site."
      },
      {
        name: "How do I submit my site for inspection?",
        text: "When you have entered the information about your site, click \"SUBMIT FOR INSPECTION\"  to submit you site for inspection."
      },
      {
        name: "When will an inspector be assigned to my site?",
        text: "After you have submitted your site by clicking \"SUBMIT FOR INSPECTION\" an inspector will be assigned to your site."
      },
      {
        name: "Can I delete my site?",
        text: "You can delete your site before you submit it for inspection by clicking the delete button. You cannot delete your site after it is submitted for inspection."
      },
      {
        name: "How do I change my password?",
        text: "Select “My Account” in the menu on the left hand side of the screen. Enter a new password. Confirm your new password and select submit. "
      }
    ]
  }),
  mounted: function() {
    this.checkLoggedIn();
  },
  methods: {
    checkLoggedIn() {
      if (checkLogin()) {
        router.push("/login");
      }

    }
  }
};
</script>
